import React from "react";
import { Card } from "antd";
import "./style.css";

const StyledCard = ({ title, onClick, disabled }) => {
  return (
    <Card className={`styled-card ${disabled ? "disabled" : ""}`} onClick={onClick}>
      <h3>{title}</h3>
    </Card>
  );
};

export default StyledCard;
